import { render, staticRenderFns } from "./johnniewalkerblonde.vue?vue&type=template&id=0b35c7e8&scoped=true&"
import script from "./johnniewalkerblonde.vue?vue&type=script&lang=js&"
export * from "./johnniewalkerblonde.vue?vue&type=script&lang=js&"
import style0 from "./johnniewalkerblonde.vue?vue&type=style&index=0&id=0b35c7e8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b35c7e8",
  null
  
)

export default component.exports